import { useState, useEffect } from 'react'
import moment from 'moment'
import { Form, Button, Row, Col, Table } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import Cookies from 'js-cookie'
import config from '../../config'
import { TypeText } from './index.styles'

export default function AffiliateStatement() {
  const [userNo, setUserNo] = useState('')
  const [affiliateData, setAffiliateData] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const dispatch = useDispatch()
  const [pagination, setPagination] = useState({
    page: 1,
    hasNext: false,
  })

  const onClickClear = () => {
    setUserNo('')
    setPagination({
      page: 1,
      hasNext: false,
    })
    setCurrentPage(1)
    setAffiliateData([])
  }

  const onSearchUser = async () => {
    try {
      dispatch({ type: 'loading_show' })
      if (userNo) {
        const params = new URLSearchParams({
          userNo: userNo,
          page: currentPage,
          limit: 10,
        })
        const response = await fetch(
          `${config.apiAdminGateway}/api/v1/admin/affiliates/statement?${params.toString()}`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get('accessToken')}`,
            },
          },
        ).then((res) => res.json())

        if (response.status.code !== 0) throw new Error(response.status.description)

        setAffiliateData(response.data)
        setPagination((pagination) => ({
          ...pagination,
          hasNext: response.pagination.hasNext,
        }))
      }
    } catch (error) {
      console.error(error)
      setAffiliateData([])
    } finally {
      dispatch({ type: 'loading_hide' })
    }
  }

  const onEnterSearch = (e) => {
    e.preventDefault()
    onSearchUser()
    setPagination({
      page: 1,
      hasNext: false,
    })
    setCurrentPage(1)
  }

  useEffect(() => {
    onSearchUser()
  }, [currentPage])

  const displayTableAffiliat = () => {
    return (
      <Table responsive striped bordered className="verticle-middle">
        <thead>
          <tr>
            <th>งวดที่</th>
            <th>คอมมิชชั่น</th>
            <th>ถอน</th>
            <th>คงเหลือ</th>
            <th>วันที่ / เวลา ที่ทำรายการ</th>
          </tr>
        </thead>
        <tbody>
          {affiliateData.length > 0 ? (
            affiliateData.map((value, i) => {
              return (
                <tr key={i}>
                  <td>{value.roundDate}</td>
                  <td>
                    <TypeText color="green">{value.commission}</TypeText>
                  </td>
                  <td>
                    <TypeText color="red">{value.withdraw}</TypeText>
                  </td>
                  <td>
                    <TypeText>{value.summary}</TypeText>
                  </td>
                  <td>{moment(value.createdAt).format('DD/MM/YYYY HH:mm')}</td>
                </tr>
              )
            })
          ) : (
            <tr>
              <td colSpan="5" style={{ textAlign: 'center' }}>
                ไม่พบข้อมูล
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    )
  }

  const handleClickNextPage = () => {
    setCurrentPage((current) => current + 1)
  }

  const handleClickPrevPage = () => {
    setCurrentPage((current) => current - 1)
  }

  return (
    <Row style={{ padding: '8px 0' }}>
      <Col sm={12}>
        <Form>
          <Form.Group>
            <Row>
              <Col sm={12}>
                <Row>
                  <Col md={12} lg={12}>
                    <input
                      className="form-control"
                      style={{ color: '#5d5d5d' }}
                      type="text"
                      placeholder="รหัสสมาชิก"
                      onChange={(e) => setUserNo(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          onEnterSearch(e)
                        }
                      }}
                      value={userNo}
                    />
                  </Col>
                  <Col sm={6} style={{ margin: '8px 0' }}>
                    <Button variant="danger light" className="w-50" onClick={() => onClickClear()}>
                      ล้างตัวกรอง
                    </Button>
                    <Button variant="primary light" className="w-50" onClick={() => onSearchUser()}>
                      ค้นหา
                    </Button>
                  </Col>
                  <Row></Row>
                </Row>
              </Col>
            </Row>
          </Form.Group>
        </Form>
        {displayTableAffiliat()}
        <div className="d-flex justify-content-center">
          <div>
            {currentPage !== 1 && (
              <button className="btn btn-primary mr-2" onClick={handleClickPrevPage}>
                ก่อนหน้า
              </button>
            )}
            <button className="btn btn-primary" disabled>
              {currentPage}
            </button>
            {pagination?.hasNext && (
              <button className="btn btn-primary ml-2" onClick={handleClickNextPage}>
                ถัดไป
              </button>
            )}
          </div>
        </div>
      </Col>
    </Row>
  )
}
